import toast, { resolveValue, ToastBar, useToaster } from 'react-hot-toast';
import { X } from 'lucide-react';

// Anchor to the bottom, away from mobile header/content menus.
// Navigation drawers (z-40) stay above transient notifications.
export function AppToaster() {
  const { toasts, handlers } = useToaster({ duration: 4000, style: { background: '#333', color: '#fff' } });
  return (
    <section aria-label="Notificações" onMouseEnter={handlers.startPause} onMouseLeave={handlers.endPause}
      onFocusCapture={handlers.startPause} onBlurCapture={e => {
        if (!e.currentTarget.contains(e.relatedTarget as Node | null)) handlers.endPause();
      }}
      className="right-4 bottom-4 w-[calc(100vw-32px)] md:w-[360px]"
      style={{ position: 'fixed', zIndex: 30, maxHeight: '40dvh', overflowY: 'auto', pointerEvents: toasts.some(t => t.visible) ? 'auto' : 'none' }}>
      {toasts.filter(t => t.visible).map(t => (
        <div key={t.id} style={{ marginBottom: 8 }}>
          <ToastBar toast={t} style={{ ...t.style, maxWidth: '100%', animation: 'none', opacity: 1 }}>
            {({ icon, message }) => <>
              {icon}{t.type === 'custom' ? resolveValue(t.message, t) : message}
              <button type="button" aria-label="Fechar notificação" onClick={() => toast.dismiss(t.id)}
                className="shrink-0 rounded p-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white hover:bg-white/10">
                <X size={16} aria-hidden="true" />
              </button>
            </>}
          </ToastBar>
        </div>
      ))}
    </section>
  );
}
